{{ accomodation.start?.toDate() | date: "dd MMMM" }}
<span *ngIf="accomodation.start && accomodation.end"> › </span>
{{ accomodation.end?.toDate() | date: "dd MMMM" }}
<span *ngIf="accomodation.city && (accomodation.start || accomodation.end)">
  &mdash;
</span>
{{ accomodation.city }}
<span
  *ngIf="
    {
      start: accomodation.start?.toDate(),
      end: accomodation.end?.toDate()
    } | daysBetween;
    let nDays
  "
>
  &mdash; {{ nDays - 1 }} notti</span
>
